import type { Mission } from '../missions.ts'

export const fas: Mission = {
  id: "fas",
  name: "Foreign Agricultural Service",
  short: "FAS",
  call: "Foreign Agriculture",
  kind: "subagency",
  parent: "usda",
  url: "https://www.fas.usda.gov/",
  palette: {
    primary: "#1b4d88",
    secondary: "#162e52",
    accent: "#dc4447",
  },
  colorSource: {
    kind: "site",
    url: "https://www.fas.usda.gov/",
  },
  motif: "globe",
  mission: {
    text: "The Foreign Agricultural Service (FAS) links U.S. agriculture to the world to enhance export opportunities and global food security.",
    url: "https://www.fas.usda.gov/about-fas",
  },
  fact: {
    text: "FAS has a global network of nearly 100 offices covering approximately 180 countries, staffed by agricultural attachés and locally hired agricultural experts.",
    url: "https://www.fas.usda.gov/about-fas",
  },
  logo: {
    file: "public/logos/fas.svg",
    source: "https://commons.wikimedia.org/wiki/File:US-ForeignAgriculturalService-Logo.svg",
  },
  identifier: {
    about: "https://www.fas.usda.gov/about-fas",
    accessibility: "https://www.usda.gov/accessibility-statement",
    foia: "https://securefoia.usda.gov/",
    oig: "https://www.oig.usda.gov/",
    privacy: "https://www.usda.gov/privacy-policy",
  },
  media: {
    photos: [
      {
        file: "/media/fas-grain-elevator.jpg",
        small: "/media/fas-grain-elevator-sm.jpg",
        alt: "A long line of covered hopper railcars waits beside the tall concrete silos and loading gantries of a riverside export grain elevator.",
        title: "Grain trains at the Westwego export elevator, Nine Mile Point, Louisiana, March 10, 2022",
        creator: "Lance Cheung, U.S. Department of Agriculture",
        source: "https://commons.wikimedia.org/wiki/File:Cargill-Westwego_Grain_Elevator_and_port_facility,_Nine_Mile_Point,_Louisiana,_10_March_2022_-_05.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
